import useApiMutation from '_api/mutations/useApiMutation';
import { ContactSupportPayload } from '_api/types';

export const SEND_SUPPORT = 'send-support';

export const useSendSupportMessage = () => {
  return useApiMutation<any, ContactSupportPayload>(
    () => '/message/support',
    'post',
    {},
    {
      mutationKey: [SEND_SUPPORT],
    },
    (body: ContactSupportPayload) => JSON.stringify(body),
  );
};
